export class Step5 {
    constructor() {}

    intitule = 'stepper.form.dive_in.step5';
    getdelaiurgence = 'form.dive_in.getdelaiurgence';

    // intitule = 'stepper.form.dive_in.step9';
    getreceptcandidatures = 'form.dive_in.getreceptcandidatures';
    getreceptoffres = 'form.dive_in.getreceptoffres';
    getenvoiinvitation = 'form.dive_in.getenvoiinvitation';
    getvalidite = 'form.dive_in.getvalidite';
    getnbjoursvalidite = 'form.dive_in.getnbjoursvalidite';
    getnbmoisvalidite = 'form.dive_in.getnbmoisvalidite';
    getdatejusquauvalidite = 'form.dive_in.getdatejusquauvalidite';
    getjusquauvalidite = 'form.dive_in.getjusquauvalidite';
    getdureevalidite = 'form.dive_in.getdureevalidite';
    getspan8 = 'form.dive_in.getspan8';
    gettextelibre = 'form.dive_in.gettextelibre';
    getintitulelibre = 'form.dive_in.getintitulelibre';
    getintitulelibrelibelle = 'form.dive_in.getintitulelibrelibelle';
    getintitule = 'form.dive_in.getintitule';
    getdateheurelibre = 'form.dive_in.getdateheurelibre';
    getspan19 = 'form.dive_in.getspan19';
}
